import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

//component:
import IntNumberFormatInput from '../../components/int_number_input_formatter';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
        margin: '8px 0'
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        marginTop: 35,
        marginLeft: 25,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 20px',
        marginBottom: 20,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    inputImporte: {
        textAlign: 'right',
    },
});

class EditPartidasPorTipoGrid extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.partida.id ? this.props.partida.id : uuidv4(),
            iTipopartidaElem: this.props.partida.iTipopartidaElem ? this.props.partida.iTipopartidaElem : this.props.tiposPartida[0].id,
            usuarioId: this.props.partida.usuarioId ? this.props.partida.usuarioId : 0,
            numPartidas: this.props.partida.numPartidas ? this.props.partida.numPartidas : 0,
            descr: this.props.partida.descr ? this.props.partida.descr : this.props.tiposPartida[0].descr,
            centroId: this.props.partida.centroId ? this.props.partida.centroId : 0.0,
            fecha: this.props.fecha ? this.props.fecha : this.props.fecha,

        }
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    }

    handleTipoChange = (event) => {

        const value = parseInt(event.target.value)

        this.setState({
            ...this.state,
            iTipopartidaElem: value,
            descr: this.props.tiposPartida.find(tz => tz.id === value).descr
        });
    }

    compare = (a, b) => {
        if (a.descr < b.descr)
            return -1;
        if (a.descr > b.descr)
            return 1;
        return 0;
    }

    fillTiposPartida = () => {
        return [...this.props.tiposPartida].sort(this.compare).map((zona, index) => {
            return (
                <option key={zona.id} value={zona.id}>{zona.descr}</option>
            );
        })
    }


    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl style={{ marginTop: 16 }} className={classes.formControl} >
                        <InputLabel htmlFor="tipo partidas">
                            Tipo de partida
                        </InputLabel>
                        <Select
                            inputProps={{tabIndex:"1"}}
                            native
                            value={this.state.iTipopartidaElem}
                            onChange={(event) => this.handleTipoChange(event)}
                            name="iTipopartidaElem"
                        >
                            {this.fillTiposPartida()}
                        </Select>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'numPartidas'}
                            label={'Número de partidas'}
                            margin="normal"
                            value={this.state.numPartidas}
                            onChange={(event) => this.handleValueChange(event, 'numPartidas')}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput, inputProps: { tabIndex: "2" } }}
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button tabIndex="4" className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button tabIndex="3" className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const partida = {
                            id: this.state.id,
                            iTipopartidaElem: this.state.iTipopartidaElem,
                            usuarioId: this.state.usuarioId,
                            numPartidas: parseInt(this.state.numPartidas),
                            descr: this.state.descr,
                            centroId: this.state.centroId,
                            fecha: this.state.fecha
                        }

                        if (this.props.checkValues(partida)) {

                            this.props.okHandler(partida);
                            this.props.hideDialog();
                        }
                    }
                    }>OK</Button>
                </div>

            </div>
        );

    };


};

EditPartidasPorTipoGrid.propTypes = {
    partida: PropTypes.object,
    okHandler: PropTypes.func.isRequired,
    checkValues: PropTypes.func.isRequired,
    usuario: PropTypes.number.isRequired,
    tiposPartida: PropTypes.array.isRequired,
    fecha: PropTypes.string.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditPartidasPorTipoGrid);